import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSessionService } from '../../session/app-session.service';

@Component({
  selector: 'dashboard-toggle',
  templateUrl: './dashboard-toggle.component.html',
  styleUrls: ['./dashboard-toggle.component.scss']
})
export class DashboardToggleComponent implements OnInit {

  isProfissional = false;

  constructor(
    private router: Router,
    private _appSessionService: AppSessionService
  ) {}

  ngOnInit(): void {
    this.isProfissional =
      this._appSessionService.user?.tipoUsuario === 'ProfissionalSaude';
  }

  isActive(route: string): boolean {
    return this.router.url.startsWith(route);
  }

  goTo(route: string) {
    this.router.navigate([route]);
  }
}
